import { FC } from 'react'
import { BaseAlert, Button } from '@/dc-shared-web/src'
import { faCheckCircle } from '@document-crunch/pro-regular-svg-icons'
import { useUploadCrunch } from '@/app/(dashboard)/upload/UploadCrunchProvider'

type Step3Props = {
  onClose: () => void
}

export const Step3: FC<Step3Props> = ({ onClose }) => {
  const { stepsData } = useUploadCrunch()

  /* It's safe to use the ? operator here because the file is required in previous steps. */
  const fileName = stepsData.step1.file?.name

  return (
    <div className='tw-space-y-4'>
      <BaseAlert
        variant='info'
        title='Crunch in progress'
        icon={faCheckCircle}
        description={
          <div className='tw-space-y-2 tw-text-base'>
            <p>
              <strong className='tw-break-all'>{fileName}</strong> has
              successfully uploaded.
            </p>
            <p>
              Once the crunch (and any checklists or playbook) finishes
              processing,{' '}
              <strong>you will receive an email notification</strong>.
            </p>
          </div>
        }
      />
      <div className='tw-text-right tw-space-x-2'>
        <Button onClick={onClose} variant='outline' data-testid='close-button'>
          Close
        </Button>
      </div>
    </div>
  )
}
